import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Button,
  Modal,
  Form,
  Col,
  Table,
  Spin,
  Select,
  Divider,
  Tag,
} from "antd";

import { CheckCircleOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { rightAction } from "../../../redux/actions";
import { apiConfig, labelConfig, staticConfig } from "../configurations.config";

const { Text, Title } = Typography;

const columns = [
  {
    title: "Code Name",
    dataIndex: "codeName",
    sorter: (a, b) => a.codeName.localeCompare(b.codeName),
  },
  {
    title: "System Defined",
    dataIndex: "systemDefined",
    sorter: (a, b) => a["systemDefined"].localeCompare(b["systemDefined"]),
  },
];

const ManageCodes = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [codeList, setCodeList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    getCodeList();
    BOM.HasPermission("CREATE_CODE") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getCodeList = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.Codes, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempCodeList = [];

        objList.forEach((element) => {
          tempCodeList.push({
            key: element?.id,
            id: element?.id,
            codeName: element?.name ? element?.name : "-",
            systemDefined: element?.systemDefined ? "true" : "false",
          });
        });

        setCodeList(tempCodeList);
        setOriginalList(tempCodeList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.Codes, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempCodeList = [];

          objList.forEach((element) => {
            tempCodeList.push({
              key: element?.id,
              id: element?.id,
              codeName: element?.name ? element?.name : "-",
              systemDefined: element?.systemDefined ? "true" : "false",
            });
          });

          resolve(tempCodeList);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE

    setSelectedRow(objParam[0]);
    dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    BOM.HasPermission("CREATE_CODE") && rightAction(cnt.RIGHT_ADD_BTN);

    const additionalButtons =
      objParam[0].systemDefined === "true"
        ? [BOM.HasPermission("READ_CODE") && cnt.RIGHT_DETAIL_BTN]
        : [
            BOM.HasPermission("READ_CODE") && cnt.RIGHT_DETAIL_BTN,
            BOM.HasPermission("DELETE_CODE") && cnt.RIGHT_DELETE_BTN,
            BOM.HasPermission("UPDATE_CODE") && cnt.RIGHT_EDIT_BTN,
          ];

    // Dispatch valid items
    additionalButtons.filter(Boolean).forEach((item) => {
      dispatch({ type: item });
    });
  };
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setCodeList(originalList);
      return;
    }
    const filterBySearch = originalList.filter((item) =>
      item?.codeName?.toLowerCase().includes(searchKey?.toLowerCase())
    );
    setCodeList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-code", { state: { id: selectedRow.id } });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-code", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }
  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-code", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const handleOnDelete = () => {
    let action = "Delete  ";
    let name = `${selectedRow.codeName}`;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + name,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.Codes}/${selectedRow.key}`;
        let body = {
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteCodeMsg);
            // navigate("/manage-paymen");
            getCodeList();
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
      onDelete={handleOnDelete}
    >
      <TopContent
        pageTitle={labelConfig.manageCodes}
        pageItems={staticConfig.manageCodeItems}
      />

      <Card
        title={`${labelConfig.code} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name"
                style={{
                  width: 400,
                }}
                allowClear
              />
            </div>
            <DownloadTableButtons
              downloadData={codeList}
              columns={columns}
              fileName={"Code List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={codeList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageCodes);
